<section class="relative z-10">
  <app-banner />
</section>
<section
  class="relative z-20 -mt-20 flex flex-row rounded-lg bg-white p-4 md:mx-6 md:p-6"
>
  <div class="flex-1">
    <div class="mb-4 flex flex-row flex-wrap items-center gap-4">
      <h1 class="whitespace-normal text-3xl font-bold text-greyscale-900">
        {{ this.tripService.trip()?.title }}
      </h1>
      <div class="flex flex-1 justify-between">
        <p-button
          icon="pi pi-pencil"
          variant="outlined"
          [label]="'edit' | transloco"
          (onClick)="tripCreationModalService.updateTrip()"
        />
        <ng-content />
      </div>
    </div>
    <div class="flex flex-col gap-4 lg:flex-row">
      <div class="flex flex-row items-center gap-1">
        <i class="pi pi-calendar text-gray-400"></i>
        <span class="text-paragraph-s-med text-gray-400"
          >{{ "calculator.tripDuration" | transloco }} :</span
        >
        <span class="text-paragraph-s-med text-gray-900"
          >{{ this.tripService.trip()?.days }}
          {{
            (this.tripService.trip()?.days ?? 0 > 1)
              ? ("travelBoards.days" | transloco)
              : ("travelBoards.day" | transloco)
          }}</span
        >
      </div>
      <div class="hidden border border-gray-200 lg:block"></div>
      <div class="flex flex-row items-center gap-1">
        <i class="pi pi-users text-gray-400"></i>
        <span class="text-paragraph-s-med text-gray-400"
          >{{ "travelBoards.travellers" | transloco }} :</span
        >
        <span class="text-paragraph-s-med text-gray-900"
          >{{ this.tripService.trip()?.travellers }}
          {{
            (this.tripService.trip()?.travellers ?? 0 > 1)
              ? ("travelBoards.people" | transloco)
              : ("travelBoards.person" | transloco)
          }}</span
        >
      </div>
      <div class="hidden border border-gray-200 lg:block"></div>
      <div class="flex flex-row items-center gap-1">
        <i class="pi pi-map-marker text-gray-400"></i>
        <span class="text-paragraph-s-med text-gray-400"
          >{{ "travelBoards.country" | transloco }} :</span
        >
        @if (isCountryMissing) {
          <button
            type="button"
            class="inline-flex cursor-pointer items-center gap-1 text-paragraph-s-med text-red-600 hover:underline"
            (click)="tripCreationModalService.updateTrip()"
          >
            <i class="pi pi-exclamation-circle"></i>
            {{ "validation.countryMissing" | transloco }}
          </button>
        } @else {
          <span class="text-paragraph-s-med text-gray-900">{{
            countryName
          }}</span>
        }
      </div>
      @if (hasClient) {
        <div class="hidden border border-gray-200 lg:block"></div>
        <div class="flex flex-row items-center gap-1">
          <i class="pi pi-users text-gray-400"></i>
          <span class="text-paragraph-s-med text-gray-400"
            >{{ "impactReport.tripHeader.clients" | transloco }} :</span
          >
          <span class="text-paragraph-s-med text-gray-900">{{
            clientName
          }}</span>
        </div>
      }
      <div class="hidden border border-gray-200 lg:block"></div>
      <div class="flex flex-row items-center gap-1">
        <i class="pi pi-calendar text-gray-400"></i>
        <span class="text-paragraph-s-med text-gray-400"
          >{{ "calculator.lastUpdate" | transloco }} :</span
        >
        <span class="text-paragraph-s-med text-gray-900"
          >{{ tripService.trip()?.updatedAt | date: "dd/MM/yyyy" }}
        </span>
      </div>
      @if (hasBrochures) {
        <div class="hidden border border-gray-200 lg:block"></div>
        <div class="flex flex-row items-center gap-1">
          <i class="pi pi-file-pdf text-gray-400"></i>
          <span class="text-paragraph-s-med text-gray-400"
            >{{ (brochures.length > 1 ? "dashboard.brochures" : "dashboard.brochure") | transloco }} :</span
          >
          <span class="flex flex-row gap-2">
            @for (doc of brochures; track doc.id) {
              <!-- TODO GRE-414: restore download when S3 URL bug is fixed
              <button
                (click)="brochureDownloadService.downloadBrochure(doc.s3Url, doc.originalFileName)"
                class="cursor-pointer text-paragraph-s-med text-primary-600 hover:text-primary-800 hover:underline"
                [pTooltip]="getBrochureTooltip(doc.originalFileName)"
                tooltipPosition="bottom"
              >
                {{ brochureDownloadService.truncateFilename(doc.originalFileName) }}
              </button>
              -->
              <span
                class="text-paragraph-s-med text-greyscale-900"
                [pTooltip]="doc.originalFileName"
                tooltipPosition="bottom"
              >
                {{ brochureDownloadService.truncateFilename(doc.originalFileName) }}
              </span>
            }
          </span>
        </div>
      }
    </div>

    <!-- Validation Badge -->
    <div
      class="mt-2 flex flex-row flex-wrap items-center justify-between gap-2"
    >
      <app-trip-validation-badge
        tooltipPosition="bottom"
        [clickAction]="scrollToFirstInvalidItem"
      />
    </div>
  </div>
</section>
